/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Sep 19 2023
 **/

import styled from "@emotion/styled";

import { Column, Icon, Row, Typography } from "@/frameworks/designStuff/components";
import { hoverScrollCss } from "@/frameworks/designStuff/utils";

export const FileBoxListWrapper = styled(Column)`
	min-width: 360px;
	width: 360px;
	height: 100%;
	padding: 24px 0 24px 20px;
	background: ${({ theme }) => theme.colors.neutral_10_100};
	margin: 0;
`;

export const FileBoxWrapper = styled(Row.li)<{ hoverBackground?: keyof Colors; focus: boolean }>`
	width: 100%;
	padding: 6px 0px 6px 5px;
	border-radius: 15px;
	cursor: pointer;
	background-color: ${({ theme, focus }) => focus && theme.colors.accent_10_100};
	&:hover {
		background-color: ${({ hoverBackground, theme }) =>
			hoverBackground ? theme.colors[hoverBackground] : theme.colors.secondary_80_8};
	}
`;

export const MyFolderWrapper = styled(Column)<{ isOpen: boolean }>`
	max-height: ${({ isOpen }) => (isOpen ? "50%" : "61px")};
	width: 100%;
`;

export const MyFolderList = styled(Column.ul)`
	max-height: 100%;
	width: 100%;
	overflow: auto;
`;

export const MyFileArrowIcon = styled(Icon)<{ open: boolean }>`
	transform: ${({ open }) => open && "rotate(180deg)"};
`;

export const SpaceStatusChip = styled(Typography)<{ status: "deleted" | "participated" }>`
	padding: 4px 8px;
	border-radius: 12px;
	margin-left: auto;
	text-wrap: nowrap;
	background-color: ${({ theme, status }) => {
		switch (status) {
			case "deleted":
				return theme.colors.error_30_100;
			case "participated":
				return theme.colors.deco7_50_100;
		}
	}};
`;

export const SpaceName = styled(Typography)<{ deleted: boolean; isEntered: boolean }>`
	width: ${({ deleted, isEntered }) => {
		const AVATAR = 24;
		const GAP = 12 * 2;
		let BADGE = 0;
		if (deleted) {
			BADGE += 42;
		}
		if (isEntered) {
			BADGE += 42;
		}

		const all = AVATAR + GAP + BADGE;
		return `calc(100% - ${all}px)`;
	}};
`;

export const FolderWrapper = styled(Column)`
	width: 100%;
	max-height: 100%;
	padding-right: 28px;
	${hoverScrollCss()}
`;
